export default "__VITE_ASSET__e065fc41__"